import { useEffect } from "react";

import { useConsentStore } from "@/consent/useConsentStore";
import { getOrCreateVisitorId } from "@/utils/visitorId";

let hasFired = false;

function view(): void {
  if (hasFired) return;
  try {
    if (typeof window === "undefined" || typeof window.podscribe !== "function")
      return;
    window.podscribe("view", { device_id: getOrCreateVisitorId() });
    hasFired = true;
  } catch (error) {
    console.error("Failed to fire Podscribe view:", error);
  }
}

export default function PodscribeView(): null {
  const marketing = useConsentStore((s) => s.consent.marketing);

  useEffect(() => {
    if (!marketing) return;
    if (typeof window.podscribe === "function") {
      view();
      return;
    }
    const onReady = (): void => view();
    window.addEventListener("podscribe:ready", onReady, { once: true });
    return () => {
      window.removeEventListener("podscribe:ready", onReady);
    };
  }, [marketing]);

  return null;
}
